exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.login-out[data-v-fd12cf40]{width:140px;height:55px;background:#F04037;border-radius:0px 0px 10px 10px;cursor:pointer;font-size:16px;font-weight:600;color:#FFFFFF;text-align:center;line-height:55px\n}\n", "", {"version":3,"sources":["/Users/sogouo/Company/bk/front/euc-player/src/views/layout/LoginOut.vue"],"names":[],"mappings":";AA0BA,4BACE,YACA,YACA,mBACA,gCACA,eACA,eACA,gBACA,cACA,kBACA,gBAAiB;CAClB","file":"LoginOut.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.login-out {\n  width: 140px;\n  height: 55px;\n  background: #F04037;\n  border-radius: 0px 0px 10px 10px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 55px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fd12cf40","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/LoginOut.vue
// module id = OCcB
// module chunks = 1